var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-btn map-top-item",
      class: {
        active: _vm.is_user_select_products,
        open: _vm.is_open_product_setting_dialog
      },
      attrs: { id: "product_btn" }
    },
    [
      _vm.show_product_btn_notice
        ? _c("div", { staticClass: "btn-notice__content" }, [
            _vm._v("\n        圖資的調整請按這裡\n        "),
            _c(
              "button",
              {
                staticClass: "btn-notice__btn",
                on: { click: _vm.not_show_product_btn_notice }
              },
              [_vm._v("\n            知道了\n        ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-btn__container",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.open_product_setting_dialog.apply(null, arguments)
            }
          }
        },
        [
          _c("v-icon", { staticClass: "product-btn__icon" }, [
            _vm._v("\n            icon-selected-data-setting\n        ")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !this.is_open_product_setting_dialog,
                  expression: "!this.is_open_product_setting_dialog"
                }
              ],
              staticClass: "product-btn__text"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("__product_setting.title")) +
                  "\n        "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }